import React from "react";

export default function InputRadioGroup({className, label, required, children,name, direction = "horizontal" }) {

    return <div className={`input-radio-group ${className}`}>
        {label && <label className="small--bold" htmlFor={name}>
			{required ? `${label} *` : label}
		</label>}
        <div className={direction === "horizontal" ? "input-radio-group__wrapper" : "input-radio-group__wrapper--vertical"}>
            {children}
        </div>
    </div>
}